export const defaultState = () => {
  const defaultFilter = "dateASC";
  const limit = 5;
  return {
    shopList: {
      fetched: false,
      list: [],
      filter: defaultFilter,
      reverse: false,
      pagination: {
        page: 1,
        limit: limit
      },
      status: {
        loading: false,
        success: false,
        error: false
      }
    },
    shopLogStatus: {
      loading: false,
      error: null,
      success: null
    },
    shopUnlinkStatus: {
      loading: false,
      error: false,
      success: false,
    },
    fetched: false,
    logged: false,
    info: {},
    search: "",
    status: {
      loading: false,
      success: false,
      error: false
    },
    isOpenSwitchModal: false
  };
};

const state = defaultState();

export default state;